import PropTypes from 'prop-types';

import Card from '#globalComponents/Card/Card';
import ProgressBar from '#globalComponents/ProgressBar/ProgressBar';
import { formatCount } from '#lib/numberFormat';

const CreditRow = ({ label, total, assigned }) => {
	const available = Math.max(total - assigned, 0);

	return (
		<div className="space-y-2">
			<div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-0.5 text-sm">
				<span className="whitespace-nowrap font-medium text-text">{label}</span>
				<span className="text-bgBase-800">
					{formatCount(assigned)} von {formatCount(total)} vergeben · {formatCount(available)} verfügbar
				</span>
			</div>
			<ProgressBar value={assigned} max={total} />
		</div>
	);
};

CreditRow.propTypes = {
	label: PropTypes.string.isRequired,
	total: PropTypes.number.isRequired,
	assigned: PropTypes.number.isRequired,
};

export const CreditsOverview = ({ orgCredits }) => {
	if (!orgCredits) return null;

	return (
		<Card className="space-y-4">
			<h3 className="text-sm font-semibold text-text">Organisations-Credits</h3>
			<CreditRow
				label="Firmen-Credits"
				total={orgCredits.quota?.companyQuota || 0}
				assigned={orgCredits.allocated?.company || 0}
			/>
			<CreditRow
				label="Kontakt-Credits"
				total={orgCredits.quota?.contactQuota || 0}
				assigned={orgCredits.allocated?.contact || 0}
			/>
		</Card>
	);
};

CreditsOverview.propTypes = {
	orgCredits: PropTypes.shape({
		quota: PropTypes.shape({
			companyQuota: PropTypes.number,
			contactQuota: PropTypes.number,
		}),
		allocated: PropTypes.shape({
			company: PropTypes.number,
			contact: PropTypes.number,
		}),
	}),
};
